import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService,CeresTagService, DataService } from 'src/api/services';
import { CustomerApplication } from 'src/api/models';
import { ActivatedRoute } from '@angular/router';
import { OpenStreetMapComponent } from 'src/app/components/open-street-map/open-street-map.component';


import * as Highcharts from "highcharts/highstock";
import theme from 'highcharts/themes/brand-dark';
import { IconService } from 'src/service/icon.service';
theme(Highcharts);


@Component({
  selector: 'app-ceres-tag-farm',
  templateUrl: './farm.component.html',
  styleUrls: ['./farm.component.css']
})
export class CeresTagFarmComponent implements OnInit {
  @ViewChild('streetMap', { read: OpenStreetMapComponent, static: false }) map: OpenStreetMapComponent;

  Highcharts = Highcharts;
  
  activityChart: Highcharts.Chart;
  temperatureChart: Highcharts.Chart;
  chartConstructor = "chart";
  activityChartCallback: Highcharts.ChartCallbackFunction;
  temperatureChartCallback: Highcharts.ChartCallbackFunction;
  chartOptions?: Highcharts.Options;

  public config: any;
  public application : CustomerApplication;
  public newFarmName: string;
  private farmId: string;
  public farm: any;
  private selectedReport: string;

  public tagCount: string = '...';

  constructor(
    private service: ApplicationService,
    private app: ApplicationConfigService,
    private route: ActivatedRoute,
    private dataService: DataService,
    public azureAuthService: AzureAuthService,
    public customerService: CustomerService,
    public icons: IconService,
    private toasterService: ToastrService,
    private ceres: CeresTagService) { 
      app.customerChanged$.subscribe(cid => {
        this.ngOnInit();
      });
  }

  ngOnInit(): void {    
    var currentTime = new Date();
    this.chartOptions = ({
      chart: {
        backgroundColor: "transparent",
        height: 150
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      time: {
        timezoneOffset: -this.app.getTimeZoneOffset(null)
      },
      legend: {
        borderWidth: 0,
        margin: 5,
        className: 'legend',
        enabled: false
      },
      xAxis: {
        type: "datetime",
        title: { text: null },
        ordinal: false,
        plotLines: [
          {
            color: "grey",
            dashStyle: "longdash",
            width: 1,
            value: currentTime.getTime() + 2000,
            zIndex: 10000,
          },
        ] as any[],
      },
      yAxis: [
        {
          title: {
            text: null,
          },
          startOnTick: false,
          endOnTick: false,
          lineWidth: 1
        },
        {
          // Secondary yAxis
          title: {
            text: null,
          },

          opposite: true,
          startOnTick: true,
          endOnTick: true
        },
      ],
      plotOptions: {
        series: {
          allowPointSelect: true,
        }
      },
      tooltip: {
        shared: true,
      },
      rangeSelector:{
        enabled: false
      }
    });

    this.activityChartCallback = chart => {
      this.activityChart = chart;
    }
    this.temperatureChartCallback = chart => {
      this.temperatureChart = chart;
    }

    this.route.params.subscribe(params => {
      this.farmId = params["farmId"];
      this.app.customerId = params["customerId"];
      
      if (this.azureAuthService.isAdmin()){
        if (this.app.customers == null){
          this.customerService.CustomerGetAllCustomers().subscribe(c => { 
            this.app.customers = c;
            this.loadCustomer();
          });
        }else{
          this.loadCustomer();
        }
      } else {
        if (this.app.customerId == null) {
          this.app.customerId = this.azureAuthService.userProfile.customerId;
        }
        this.loadCustomer();
      }
    });
  }

  loadCustomer(){
    this.ceres.CeresTagGet(this.app.customerId).subscribe(s => {
      this.application = s;

      this.farm = this.application.applicationConfiguration.farms.find(f => f.identifier == this.farmId);
      this.config = this.application.applicationConfiguration;
      this.selectedReport = 'last1';
      this.loadHeatMap('-1d:1d');
    });
  }

  changeCustomer(){
    this.loadCustomer();
  }

  loadHeatMap(period){
    
    this.dataService.DataGetDataForMatch({customerId: this.app.customerId, request:{
      index: 0,
      period: period,
      siteUri: this.farmId,
      forceEmbed: false,
      timeZoneOffset: this.app.getTimeZoneOffset(null),
      timeSeries: {
        single: {
          variable:{
            tagMatches: [{tagName:"siteType",tagValue:"CeresTag"},{tagName:"farmIdentifier",tagValue:this.farmId}]
          }
        }
      }      
    } }).subscribe(r => {
      var latest = [];
      const all = [];
      var pin = this.icons.pins.gold;
      this.tagCount = r.length.toString();
      while(this.activityChart.series.length>0){
        this.activityChart.series[0].remove(false) //false = don't redraw
      }
      while(this.temperatureChart.series.length>0){
        this.temperatureChart.series[0].remove(false) //false = don't redraw
      }
      //chart.redraw() 
      for (let tag of r){
        this.map.loadHeatmap(tag.uri, tag.values, null, 50);
        if (tag.values.length > 0){
          var last = tag.values[tag.values.length - 1] as any;
          latest.push({
            type: 'TimeSeries',
            siteName: tag.name,
            siteDescription: 'Latest Location',
            siteType: 'CeresTag',
            name: tag.name,
            description: last.metaData.ActivityDetail,
            uri: tag.uri,
            icon: pin,
            latestValue: last.coordinate,
            latestTime: last.timeStamp,
            latitude: last.coordinate.latitude,
            //latitudeTxt: item.latitude == null ? null : Math.round(item.latitude*1000)/1000,
            longitude: last.coordinate.longitude,
            //longitudeTxt: item.longitude == null ? null : Math.round(item.longitude*1000)/1000
          });
        }
        var activity = [];
        var temperature = [];
        for (let v of tag.values){
          if (Number(v.metaData.Activity) > 0) {
            // hide 0 - this means nothing recorded.
            activity.push([new Date(v.timeStamp).getTime() , Number(v.metaData.Activity)]);
          } else {
            activity.push([new Date(v.timeStamp).getTime() , null]);
          }
          temperature.push([new Date(v.timeStamp).getTime() , Number(v.metaData.Temperature)]);
        }
        all.push(activity);   

        var activitySeries = {
          name: tag.name,
          yAxis: 0,
          type: 'spline',
          lineWidth: 1,
          enabled: true,
          marker: {
            enabled: true,
          },
          data: activity
        };        
        this.activityChart.addSeries(activitySeries as Highcharts.SeriesTimelineOptions);

        var temperatureSeries = {
          name: tag.name,
          yAxis: 0,
          type: 'spline',
          lineWidth: 1,
          enabled: true,
          marker: {
            enabled: true,
          },
          data: temperature
        };        
        this.temperatureChart.addSeries(temperatureSeries as Highcharts.SeriesTimelineOptions);
      }
      

      this.map.showSearchResult(latest, 
        // onload
        (marker, item) => {},
        // onselect
        (marker, item) => {}, false);
      });
  }

  selectReport(name:string){
    this.map.clearSearchResults();

    this.selectedReport = name;
    if (this.selectedReport == 'last1'){      
      this.loadHeatMap('-1d:1d');
    } else if (this.selectedReport == 'last7'){      
      this.loadHeatMap('-7d:1d');
    } else if (this.selectedReport == 'last30'){
      this.loadHeatMap('-30d:1d');
    } else if (this.selectedReport == 'latest'){
      this.map.clearSearchResults();
      var searchFilter = 'mt:siteType="CeresTag" mt:farmIdentifier="' + this.farm.identifier + '"';
      this.dataService.DataSearch({customerId: this.app.customerId, search: searchFilter, searchSize: 500, pageIndex: 0, includeAlarms: false, filterOld: true}).subscribe(r => {
        var all = [];
        if (r){
          for (let source of r){
            for (let item of source.items){
              var pin = this.icons.pins.gold;
              /*if (item.latestTime < now-6 hours){
                pin = this.map.pins.red;
              }*/
              all.push({
                type: source.type,
                siteName: source.siteName,
                siteType: source.siteType,
                siteDescription: source.siteDescription,
                name: item.name,
                description: item.description,
                uri: item.uri,
                icon: pin,
                latestValue: item.latestValue,
                latestTime: item.latestTime,
                latitude: item.latitude,
                latitudeTxt: item.latitude == null ? null : Math.round(item.latitude*1000)/1000,
                longitude: item.longitude,
                longitudeTxt: item.longitude == null ? null : Math.round(item.longitude*1000)/1000
              });
              
            }
          }
        }

        this.map.showSearchResult(all, 
          // onload
          (marker, item) => {
            // if the age of the data is more than 6 hours, then show red icon

            /*if (this.findTimeSeries(item.uri)){
              marker.setIcon(this.map.selectedIcon);
            }*/
          },
          // onselect
          (marker, item) => {
            /*var ts = this.findTimeSeries(item.uri)
            if (ts){
              marker.setIcon(this.map.defaultIcon);
              this.removeTimeSeries(ts);
            } else {
              marker.setIcon(this.map.selectedIcon);
              this.addTimeSeries(item);
            }*/
          }, false);
      });
    }
  }

  drawing: boolean;
  startDrawing(){
    this.drawing = true;
    this.map.startEdit();
  }

  cancelDrawing(){
    this.map.stopEdit();
    this.drawing = false;
  }

  finishDrawing(){
    var shapes = this.map.getShape();
    var shapeObjects = [];
    
    for (let s of shapes){
      shapeObjects.push(JSON.stringify(s));
    }
    this.farm.geoJsonObjects = shapeObjects;

    this.ceres.CeresTagUpdateFarm({customerId:this.app.customerId, farm: this.farm}).subscribe(r => {
      this.toasterService.success('Farm Updated');
      this.map.stopEdit();
      this.drawing = false;
    }, e =>{
      this.toasterService.error('Farm Update Failed');
    })
  }
}
